import { API_BASE_URL } from "./apiConfig";
import { handleApiResponse } from "./apiUtils";

export const submitFeedback = async (feedbackData) => {
  const response = await fetch(`${API_BASE_URL}/feedbacks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(feedbackData),
  });
  return handleApiResponse(response);
};

export const updateFeedback = async (id, feedbackData) => {
  const response = await fetch(`${API_BASE_URL}/feedbacks/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(feedbackData),
  });
  return handleApiResponse(response);
};

export const deleteFeedback = async (id) => {
  const response = await fetch(`${API_BASE_URL}/feedbacks/${id}`, {
    method: 'DELETE',
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getFeedbackById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/feedbacks/${id}`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getAllFeedbacks = async () => {
  const response = await fetch(`${API_BASE_URL}/feedbacks`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getFeedbacksByUserId = async (userId) => {
  const response = await fetch(`${API_BASE_URL}/feedbacks/user/${userId}`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};

export const getFeedbacksByExhibitionId = async (exhibitionId) => {
  const response = await fetch(`${API_BASE_URL}/feedbacks/exhibition/${exhibitionId}`, {
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};
